import template from './dynamicLinkEditForm.html';
import controller from './dynamicLinkEditForm.controller';
import './dynamicLinkEditForm.scss';

let dynamicLinkEditFormComponent = {
  restrict: 'E',
  bindings: {
    save: '&',
    validation: '<',
    dynamicLink: '=',
    storeFile: '&'
  },
  template,
  controller
};

export default dynamicLinkEditFormComponent;
